
document.addEventListener('DOMContentLoaded', function () {
  function initInfiniteScroll() {
    
    const grid = document.getElementById('product-grid');
    const trigger = document.getElementById('load-more-trigger');     
    const productsPerPage = grid.dataset.products_per_page;  
    const collectionHandle = grid.dataset.collectionhandle;    
    
    let currentPage = 1;
    let leftovers = [];
    let loading = false;

    if (!grid || !trigger) return;

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        console.log('[OBSERVE] Trigger in view, loading next batch...');
        loadNextBatch();
      }
    }, { rootMargin: '0px 0px 200px 0px' }); // Trigger 500px before the viewport

    observer.observe(trigger);

    function buildAjaxURL(page) {
      const params = new URLSearchParams(window.location.search);
      params.set('page', page);
      params.set('view', 'ajax');
      return `/collections/${collectionHandle}?${params.toString()}`;
    }
    
    function loadNextBatch() {
      console.log('before in loadNextBatch',loading);
      if (loading) return;
      console.log('after in loadNextBatch',loading);
      loading = true;
      trigger.classList.add('loading');

      // If we already have enough leftovers, render them first
      if (leftovers.length >= productsPerPage) {
        const toRender = leftovers.slice(0, productsPerPage);
        leftovers = leftovers.slice(productsPerPage);
        console.log(`[LEFTOVERS] Rendering ${toRender.length}, leftover after: ${leftovers.length}`);
        

        // Small delay so the observer doesn't immediately fire again        
        setTimeout(() => {  
          renderProducts(toRender);  
          loading = false;      
          trigger.classList.remove('loading');

          // If still not filling the viewport and no leftovers, auto-fetch next
          if (leftovers.length === 0) {
            loadNextBatch();
          }
        }, 600);

        return;
      }

      if (leftovers.length > 0) {
        console.log(`[LEFTOVERS] Have only ${leftovers.length}, fetching next page to complete batch...`);
      }

      const url = buildAjaxURL(currentPage);
      console.log(`[FETCH] Getting page ${currentPage} → ${url}`);

      fetch(url)
        .then(res => res.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const fetchedItems = Array.from(tempDiv.querySelectorAll('.grid__item'));
          console.log(`[FETCHED] ${fetchedItems.length} products fetched from page ${currentPage}`);

          // No items returned → render any final leftovers and stop
          if (fetchedItems.length === 0) {
            if (leftovers.length > 0) {
              console.log('[END] No more products to fetch. Rendering final leftovers.');
              renderProducts(leftovers);
              leftovers = [];
            } else {
              console.log('[END] No more products and no leftovers. Removing trigger.');
            }
            observer.unobserve(trigger);
            trigger.remove();
            loading = false;
            trigger.classList.remove('loading');
            return;
          }

          // De-dupe vs already rendered + pending leftovers
          const renderedIDs = new Set(
            Array.from(document.querySelectorAll('.grid__item[data-product-id]'))
              .map(el => el.getAttribute('data-product-id'))
          );
          const leftoverIDs = new Set(leftovers.map(el => el.getAttribute('data-product-id')));
          const uniqueProducts = fetchedItems.filter(item => {
            const id = item.getAttribute('data-product-id');
            return id && !renderedIDs.has(id) && !leftoverIDs.has(id);
          });

          // Combine leftovers + new uniques
          let combined = leftovers.concat(uniqueProducts);

          // If total < page size, keep accumulating and auto-fetch next page
          if (combined.length < productsPerPage) {
            leftovers = combined;            // carry forward (don’t render yet)
            currentPage++;
            console.log(`[AUTO-FETCH] Only ${combined.length} accumulated, loading next page...`);

            loading = false;                 // allow recursion
            trigger.classList.remove('loading');
            loadNextBatch();
            return;
          }

          // Render exactly a page, or everything if equal
          let toRender, newLeftovers;
          if (combined.length <= productsPerPage) {
            toRender = combined;
            newLeftovers = [];
          } else {
            toRender = combined.slice(0, productsPerPage);
            newLeftovers = combined.slice(productsPerPage);
          }

          
          leftovers = newLeftovers;
          currentPage++;

          setTimeout(() => {
            console.log(`[RENDER] Rendering ${toRender.length} items (combined leftovers + new)`);
            renderProducts(toRender);
            loading = false;
            trigger.classList.remove('loading');

            // If the grid is still shorter than the viewport and nothing pending, fetch again
            if (leftovers.length === 0) {
              loadNextBatch();
            }
          }, 600);
        })
        .catch(err => {
          console.error('[ERROR]', err);
          loading = false;
          trigger.classList.remove('loading');
        });
    }


    function showLoader() {
      const trigger = document.getElementById('load-more-trigger');
      if (trigger) trigger.classList.add('loading');
    }

    function hideLoader() {
      const trigger = document.getElementById('load-more-trigger');
      if (trigger) trigger.classList.remove('loading');
    }
   
    function renderProducts(cards) {
      console.log(`[renderProducts] Appending ${cards.length} product(s) to grid`);
      const fragment = document.createDocumentFragment();
      cards.forEach(card => {        
        fragment.appendChild(card);
      });
      grid.appendChild(fragment);
      
    }
  }

  initInfiniteScroll();  
  document.addEventListener('collection:updated', () => {
    initInfiniteScroll();
    //console.log('[RESET] Detected filter/sort change, resetting infinite scroll...');
  });
});
